<template>
    <AdminPanelYoutvList />
    </template>
    
    <script>
    import AdminPanelYoutvList from '../components/AdminPanelYoutvList.vue'
    export default {
        data: () => ({}),
        components: {
            AdminPanelYoutvList
        },
        methods: {},
        mounted() {}
    }
    </script>
    